// Map坐标选择器
import EdInputMap from './src/EdInputMap.vue';

/* istanbul ignore next */
EdInputMap.install = function (Vue) {
  Vue.component(EdInputMap.name, EdInputMap)
}

export default EdInputMap;
